import { z } from 'zod';
import { ErrorResponseSchema } from '@/schemas/common/base';

/**
 * POST /api/listings/[id]/confirm-photos param schema
 * Confirms photo upload and activates a draft listing
 */
export const ConfirmPhotosParamSchema = z.object({
  id: z.string().refine(val => !isNaN(parseInt(val, 10)), 'Invalid listing ID'),
});

/**
 * POST /api/listings/[id]/confirm-photos response schema
 * Returns the updated listing info
 */
export const ConfirmPhotosResponseSchema = z.discriminatedUnion('success', [
  z.object({
    success: z.literal(true),
    listing: z.object({
      id: z.number(),
      status: z.number(),
    }),
    /**
     * True when the listing is held for an admin to review before it goes live
     * (a phone number, a WhatsApp/Telegram contact or a supplier pitch in its
     * text; utils/listing-spam.ts). The seller is told it is under review.
     */
    underReview: z.boolean().optional(),
  }),
  ErrorResponseSchema,
]);

export type ConfirmPhotosParam = z.infer<typeof ConfirmPhotosParamSchema>;
export type ConfirmPhotosResponse = z.infer<typeof ConfirmPhotosResponseSchema>;
